import type { IconData } from '@stacksjs/iconify-core'

export const shareLinkSolid: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M37 1.5a9.5 9.5 0 0 0-9.328 11.31l-9.63 4.814a9.5 9.5 0 1 0 0 12.751l9.63 4.815A9.5 9.5 0 1 0 37 27.5c-2.454 0-4.69.93-6.376 2.458L20.46 24.876a9.6 9.6 0 0 0 0-1.752l10.164-5.082A9.47 9.47 0 0 0 37 20.5a9.5 9.5 0 0 0 0-19\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default shareLinkSolid
